import script from "./invoice-wtdk-4-dialog.vue?vue&type=script&lang=tsx&name=invoice-enterprise-dialog&setup=true"
export * from "./invoice-wtdk-4-dialog.vue?vue&type=script&lang=tsx&name=invoice-enterprise-dialog&setup=true"

const __exports__ = script;

export default __exports__